import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

@Component({
  selector: 'bmcore-producer-bg',
  templateUrl: './bmcore-producer-bg.component.html',
  styleUrls: ['./bmcore-producer-bg.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreProducerBgComponent implements OnInit {
  @Input() producerCover: string
  @Input() producerLogo: string

  producerDefaultCover = 'assets/images/bmstv-bg.webp'

  constructor() {}

  ngOnInit() {}
}
